var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#D7FFC4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 16.9913L17.4008 17.6722L19.9455 22.86L17.6122 24L15.0525 18.7635L12 21.5018V9.609L21.75 16.9913ZM12.156 8.8125L11.3745 9.20175L10.2225 6.8865L11.0047 6.49725L12.156 8.8125ZM14.1053 6.12975L13.2413 6L12.8565 8.55675L13.7205 8.6865L14.1053 6.12975ZM10.521 10.5157L10.9388 9.7485L8.66775 8.5125L8.25 9.27975L10.521 10.5157Z",
    fill: "#533FE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublished);
export default __webpack_public_path__ + "static/media/published.b05fdda148efdecd514914293438b43a.svg";
export { ForwardRef as ReactComponent };